import Vue from 'vue';
import Router from 'vue-router';

import auth from '@/auth/auth.router';
import portal from '@/portal/portal.router';

Vue.use(Router);

const routers = {
  auth,
  portal,
};
const {
  router: routerConfig,
  beforeEach,
  afterEach,
} = routers[GLOBALS.APP];

const router = new Router(routerConfig);

if (beforeEach) {
  router.beforeEach(beforeEach);
}
if (afterEach) {
  router.afterEach(afterEach);
}

export default router;
